<button *ngIf="readOnly || data.disabled" class="button error deleteButton" (click)="deleteRow()">Delete</button>
<button *ngIf="!readOnly && !data.disabled" class="button success saveButton" (click)="save()">Save</button>
<button class="button editButton" [ngClass]="{'error': !readOnly && !data.disabled}" (click)="toggleReadOnly()">{{readOnly || data.disabled ? 'Edit' : 'Cancel'}}</button>
